<template>
  <div :id="`${source}_uploaded_file_renderer`" class="flex flex-col gap-2">
    <div
      v-for="(file, index) in files"
      :key="`file_${index}`"
      class="flex flex-row items-center justify-between w-full p-2 text-sm rounded-lg bg_white_4"
    >
      <div class="flex flex-row items-center gap-2">
        <img
          class="size-10"
          :src="fileImage[getFileType(file)]"
          :alt="`${getFileType(file)?.toLowerCase()}_icon`"
        />
        <span class="font-normal truncate">{{ file?.name }}</span>
      </div>
      <span
        class="font-semibold cursor-pointer mx-2"
        @click="$emit('action', index)"
      >
        {{ actionText }}
      </span>
    </div>
  </div>
</template>

<script setup>
import fileTypePath from "@/src/paths/fileTypePath.js";

const props = defineProps({
  source: { type: String, required: true },
  files: { type: Array, required: true },
  actionText: { type: String, required: true },
});

const emit = defineEmits(["action"]);

const fileImage = {
  JPEG: fileTypePath.thumbnail.jpeg,
  JPG: fileTypePath.thumbnail.jpg,
  PNG: fileTypePath.thumbnail.png,
};

const getFileType = (file) => {
  if (!file) return null;
  const extension = file.name?.split(".").pop()?.toUpperCase();
  return extension || null;
};
</script>
